export default __webpack_public_path__ + "static/10-bd8d3de7e2ab56691155820a488e82e5.png";